module.exports = __webpack_public_path__ + "static/media/machine_learning_service_workspaces.3a9a761f.svg";